import HeaderToolbar from "../../components/HeaderToolbar";
import { useTranslation } from "react-i18next";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import mysmartguardplus from "../../../src/assets/USA_Images/applicationLogo.svg";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import SignatureCanvas from "react-signature-canvas";
import ClearIcon from "@mui/icons-material/Clear";
import { useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getDocuments, saveDocuments } from "../../slices/NDA/NDASlice";
import CommonUtil from "../../components/Util/CommonUtils";
import Toast from "../../components/ToastContainer/CustomToast";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import httpCommon from "../../config/http-common";
import { REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT } from "../../actions/EndPoints";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
function NDADocument(props) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const sigCanvasRef = useRef();
  const dispatch = useDispatch();
  const [ndaDocuments, setNdaDocument] = useState([]);
  const [documentIds, setDocumentsIds] = useState([]);
  const [documentURL, setDocumentURL] = useState([]);
  const history = useHistory();
  const leftWrapperRef = useRef(null);
  const rightWrapperRef = useRef(null);
  const [leftWidth, setLeftWidth] = useState(0);
  const [rightWidth, setRightWidth] = useState(0);
  const [numPages1, setNumPages1] = useState(null);
  const [numPages2, setNumPages2] = useState(null);
  const [agree, setAgree] = useState(false);
  const [ndaSignature, setNdaSignature] = useState([]);

  const onDocumentLoadSuccess1 = ({ numPages }) => {
    setNumPages1(numPages);
  };

  const onDocumentLoadSuccess2 = ({ numPages }) => {
    setNumPages2(numPages);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [scale, setScale] = useState(1.5); // Default for desktop

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      if (width < 600) {
        setScale(0.6); // Smaller scale for mobile
      } else if (width < 960) {
        setScale(1); // Tablet
      } else {
        setScale(1.5); // Desktop
      }
    };

    handleResize(); // initial
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    loadNDADOcuments();
  }, []);

  useEffect(() => {
    // Update the canvas size on window resize
    const handleResize = () => {
      if (sigCanvasRef.current) {
        const canvas = sigCanvasRef.current;
        // Resize canvas to match the container's size
        canvas.resizeCanvas(canvas.canvas.width, canvas.canvas.height);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadNDADOcuments = () => {
    dispatch(getDocuments(props.location.state.companyId))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000" && data.data) {
          setNdaDocument(data.data);
          let documentIds = data.data.map((doc) => doc.id);
          setDocumentsIds(documentIds);
          let documentURL = data.data.map((doc) => doc.documentURL);
          setDocumentURL(documentURL);
        } else {
          setNdaDocument([]);
        }
      })
      .catch((er) => {});
  };

  const handleClear = () => {
    sigCanvasRef.current.clear();
  };

  const handleCheckBox = (event) => {
    setAgree(event.target.checked);
  };

  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  const handleSubmit = () => {
    if (!agree) {
      Toast("Please agree to NDA Document", "error");
      return;
    }
    if (!sigCanvasRef.current || sigCanvasRef.current.isEmpty()) {
      Toast("Please enter the signature", "error");
      return;
    }
    if (sigCanvasRef.current) {
      const base64Signature = sigCanvasRef.current
        .getTrimmedCanvas()
        .toDataURL();
    }

    if (ndaDocuments.length > 1) {
      setNdaSignature((prev) => {
        const updatedSignature = [
          ...prev,
          sigCanvasRef.current.getTrimmedCanvas().toDataURL(),
        ];

        if (ndaDocuments.length > 1) {
          history.push({
            pathname: "/vis/secondndadocument",
            state: {
              ndaDocuments: ndaDocuments,
              ndaSignature: updatedSignature,
              documentURL: documentURL,
              code: props.location.state.code,
              companyId: props?.location?.state?.companyId,
              videoAcknowledgement:
                props?.location?.state?.videoAcknowledgement,
            },
          });
        }

        return updatedSignature;
      });
    } else if (!props?.location?.state?.videoAcknowledgement) {
      const signature = [
        ...ndaSignature,
        sigCanvasRef.current.getTrimmedCanvas().toDataURL(),
      ];
      let payload = {
        imageData: signature,
        documentIds: documentIds,
        documentURL: documentURL,
      };
      httpCommon
        .unsecuredAxios()
        .put("/web/visit/confirm/" + props.location.state.code, payload)
        .then((res) => {
          if (res.data.code === "CVAI0072") {
            history.push({
              pathname: "/vis/visit-success",
              state: { message: res.data.message, success: true },
            });
          } else {
            Toast(res.data.message, "error");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      history.push({
        pathname: REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT,
        state: {
          code: props?.location?.state?.code,
          companyId: props?.location?.state?.companyId,
        },
      });
    }
  };

  const handleCancel = () => {
    const data = data;
    httpCommon
      .unsecuredAxios()
      .put("/web/visit/rejectvisit/" + props.location.state.code)
      .then((res) => {
        if (res.data.code === "CVAI0073") {
          history.push({
            pathname: "/vis/cancel/Visit",
          });
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((e) => {
        console.log(e);
      });

    return;
  };

  return (
    <>
      <Box
        style={{
          backgroundColor: "#F4F6F8",
          height: "100vh",
        }}
      >
        <Grid
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Grid container alignItems="center">
            <Grid item className="logo-center">
              <img
                src={mysmartguardplus}
                alt="logo"
                style={{ width: "300px" }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Box
          sx={{
            backgroundColor: "white",
            height: "calc(100vh - 110px)",
            display: "flex",
            flexDirection: "column",
            marginRight: isSmallScreen ? "0px" : "70px",
            marginLeft: isSmallScreen ? "0px" : "70px",
            borderRadius: "10px",
            // gap: "8px",
          }}
        >
          <Grid
            style={{
              paddingLeft: "16px",
              paddingTop: "16px",
            }}
          >
            <HeaderToolbar title={t("NDA_DOCUMENT_SIGNATURE_HEADER")} />
          </Grid>
          <Box
            sx={{
              flex: 1,
              height: "100%",
              overflowY: "auto",
              marginTop: "10px",
            }}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: "#FBFBFB",
                  padding: isSmallScreen ? "0px" : "20px",
                  paddingBottom: "0px",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    overflowY: "auto",
                  }}
                >
                  <Document
                    file={ndaDocuments[0]?.documentURL}
                    onLoadSuccess={onDocumentLoadSuccess1}
                  >
                    {[...Array(numPages1)].map((_, index) => (
                      <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                        scale={scale}
                        className="pdf-page"
                      />
                    ))}
                  </Document>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              padding: "20px",
              paddingTop: "4px",
            }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                style={{
                  paddingBottom: "0px",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handleCheckBox}
                        sx={{
                          "&.Mui-checked": {
                            color: "rgb(242, 130, 76)",
                          },
                          color: "#949596",
                          "&.Mui-disabled": {
                            color: "#949596",
                          },
                        }}
                      />
                    }
                    label={t("NDA_MANDATORY")}
                    style={{
                      color: "rgba(71, 74, 78, 1)",
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                style={{
                  paddingTop: "0px",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    height: "120px",
                    border: "1px solid rgba(112, 112, 112, 0.5)",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <IconButton
                    onClick={handleClear}
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      zIndex: 1,
                      backgroundColor: "white",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      },
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                  <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="black"
                    canvasProps={{
                      className: "sigCanvas",
                      width: 600,
                      height: "100%",
                      style: {
                        width: "100%",
                        height: "100%",
                        display: "block",
                      },
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                style={{
                  display: "flex",
                  alignItems: "end",
                  // justifyContent: "center",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Grid item>
                    <CancelButtons
                      color="secondary"
                      onClick={handleCancel}
                      variant="contained"
                    >
                      <Typography>{t("APPROVE003")}</Typography>
                    </CancelButtons>
                  </Grid>
                  <Grid item>
                    <SubmitButtons
                      type="submit"
                      onClick={handleSubmit}
                      variant="contained"
                    >
                      <Typography>
                        {ndaDocuments.length > 1
                          ? t("VERIFYCOMP0003")
                          : t("COMMON007")}
                      </Typography>
                    </SubmitButtons>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default NDADocument;
